import {useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";
import {createNotification} from "app/actions/notifications";
import {get as getUser, update as updateUser} from "app/requests/admin/users";
import {valueFrom, valueFromTarget} from "lib/form";
import {Loading} from "components/pages";
import {usePrompt} from "lib/hooks";
import useAppContext from "lib/hooks/use-app-context";
import {withoutBlankValues} from "lib/object";
import Form from "./form";

export default function AdminUsersEdit() {
  const {dispatch} = useAppContext();
  const navigate = useNavigate();
  const {id} = useParams();
  const [block, setBlock] = useState(false);
  const [changes, setChanges] = useState({});
  const [user, setUser] = useState(null);

  usePrompt({when: block});
  useEffect(() => {
    getUser(id).then((data) => setUser(data.record));
  }, []);

  if(!user) { return <Loading />; }

  const onChange = ({target}) => {
    setBlock(true);
    setChanges({...changes, [target.name]: valueFromTarget(target)});
  };
  const onSubmit = (files) => {
    const updates = withoutBlankValues({...changes, ...files});

    if(Object.keys(updates).length === 0) {
      return dispatch(createNotification({
        content: "Please make changes before submitting",
        type: "danger"
      }));
    }

    setBlock(false);
    updateUser(user.id, {user: updates}).then((data) => {
      if(data.success) {
        navigate("/admin/users", {state: {message: data.message, type: "success"}});
      } else {
        dispatch(createNotification({content: data.message, type: "danger"}));
      }
    });
  };
  const value = (name, defaultValue) => valueFrom({
    defaultValue,
    name,
    objects: [changes, user]
  });

  return (
    <div className="container-fluid">
      <h1 className="text-center">Edit User</h1>
      <Form {...{onChange, onSubmit, value}} />
    </div>
  );
}
